<template>
    <modal ref="modalEditarPolitica" tamano="modal-xl" titulo="Editar política" no-aceptar adicional="Guardar" @adicional="editarPolitica">
        <ValidationObserver ref="formHija">
                <div class="row mx-0 j-center">
                    <div class="col-12 mb-1 mt-2">
                        <p class="label pl-3">
                            Nombre de la política
                        </p>
                        <ValidationProvider v-slot="{errors}" rules="required|max:80" name="nombre">
                            <el-input v-model="politica.titulo" class="w-100" placeholder="Nombre" maxlength="80" show-word-limit size="small" />
                            <p class="text-danger f-10">{{ errors[0] }}</p>
                        </ValidationProvider>
                    </div>
                    <div class="col-12 mt-2 mb-2">
                        <p class="label pl-3">
                            Descripción
                        </p>
                        <ValidationProvider v-slot="{errors}" name="descripción">
                            <el-input v-model="politica.respuesta" placeholder="Descripción"  type="textarea" :rows="25" show-word-limit class="w-100" size="small" />
                            <p class="text-danger f-10">{{ errors[0] }}</p>
                        </ValidationProvider>
                    </div>
                </div>
        </ValidationObserver>
    </modal>
</template>

<script>
import Configuracion from '@/services/configuracion'
export default {
    data(){
        return {
            politica: {
                id: null,
                titulo: '',
                respuesta: '',
            },
        }
    },
    methods: {
        toggle(politica){
            this.politica = politica
            this.$refs.modalEditarPolitica.toggle();
        },
        async editarPolitica(){
            try {
                
                let validate = await this.$refs.formHija.validate()
                if(!validate) return this.notificacion('','Campos incompletos')

                let params = {
                    id_faq: this.politica.id,
                    titulo: this.politica.titulo,
                    respuesta: this.politica.respuesta
                }
                
                const { data } = await Configuracion.editarFaq(params)

                this.notificacion('','Política editada correctamente','success')
                this.$refs.modalEditarPolitica.toggle();
                
                this.$emit('actualizar')
            } catch (error) {
                this.error_catch(error)
            }
        },

    }
}
</script>
<style lang="scss" scoped>
.label{
    font-size: 12px;
    color: var(--text-general);
}
</style>